(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["windlust-product-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('windlust-atelier')) {
  customElements.define('windlust-atelier', class extends HTMLElement {
    static get observedAttributes() { return ['data-motion-enabled']; }

    constructor() {
      super();
      this._frame = 0;
      this._epoch = 0;
      this._activeStep = -1;
      this._nearby = new Set();
      this._floatPointers = new Map();
      this._onScroll = () => this._schedule();
      this._onResize = () => this._schedule(true);
      this._onPreference = () => this._applyPreference();
      this._onReady = () => this._initialize();
      this._onClick = (event) => this._navigate(event);
      this._featureLinks = new Map();
      this._onFeatureClick = (event) => this._navigateFeature(event);
      this._onStrengthRefresh = () => this._connectStrengths();
      this._onPointerMove = (event) => {
        if (event.pointerType === 'touch' || !Number.isFinite(event.clientX) || !Number.isFinite(event.clientY)) return;
        this._floatPointers.set(event.currentTarget, { x: event.clientX, y: event.clientY });
        this._schedule();
      };
      this._onPointerLeave = (event) => {
        if (this._floatPointers.delete(event.currentTarget)) this._schedule();
      };
      this._onToggle = () => {
        this._paused = !this._paused;
        this.toggleAttribute('data-motion-paused', this._paused);
        this._applyPreference();
      };
    }

    connectedCallback() {
      this._connected = true;
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this._onReady, { once: true });
      else this._initialize();
    }

    disconnectedCallback() {
      this._connected = false;
      document.removeEventListener('DOMContentLoaded', this._onReady);
      this._stop();
      document.removeEventListener('shopify:section:load', this._onStrengthRefresh);
      document.removeEventListener('variant:change', this._onStrengthRefresh);
      clearTimeout(this._featureHighlightTimer);
      this._featureLinks.forEach((_, link) => {
        link.removeEventListener('click', this._onFeatureClick);
        if (link.isConnected) link.replaceWith(document.createTextNode(link.textContent));
      });
      this._featureLinks.clear();
      this.removeEventListener('click', this._onClick);
      this._toggle?.removeEventListener('click', this._onToggle);
      this._reduced?.removeEventListener('change', this._onPreference);
      this._compact?.removeEventListener('change', this._onPreference);
      this._pointer?.removeEventListener('change', this._onPreference);
      this._restore();
      this._initialized = false;
    }

    attributeChangedCallback(name, previous, next) {
      if (name === 'data-motion-enabled' && previous !== next && this._initialized) this._applyPreference();
    }

    _initialize() {
      if (!this._connected || this._initialized) return;
      this._track = this.querySelector('[data-atelier-track]');
      this._stage = this.querySelector('[data-atelier-stage]');
      this._coreArt = this.querySelector('.wl-atelier__core-art');
      this._panels = Array.from(this.querySelectorAll('[data-atelier-panel]'));
      this._steps = Array.from(this.querySelectorAll('[data-atelier-step]'));
      this._cards = Array.from(this.querySelectorAll('[data-atelier-card]'));
      this._floats = Array.from(this.querySelectorAll('[data-atelier-float]'));
      this._toggle = this.querySelector('[data-atelier-toggle]');
      if (!this._track || !this._stage || !this._panels.length) return;
      this._initialized = true;
      this._paused = this.hasAttribute('data-motion-paused');
      this._reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._compact = window.matchMedia('(max-height: 710px), (max-width: 749px) and (max-height: 740px)');
      this._pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      this._reduced.addEventListener('change', this._onPreference);
      this._compact.addEventListener('change', this._onPreference);
      this._pointer.addEventListener('change', this._onPreference);
      this.addEventListener('click', this._onClick);
      this._toggle?.addEventListener('click', this._onToggle);
      this._applyPreference();
      this._connectStrengths();
      document.addEventListener('shopify:section:load', this._onStrengthRefresh);
      document.addEventListener('variant:change', this._onStrengthRefresh);
    }

    _strengthDestination(text) {
      const label = text.toLowerCase();
      const finish = this.dataset.finishFeature;
      if (/vegan leather/.test(label)) return 'material';
      if (/ergonomic|hand[ -]?cut|roomier footbed/.test(label)) return 'cut';
      if (/crystal|swarovski/.test(label)) return finish === 'crystal' ? 'finish' : null;
      if (/stone/.test(label)) return finish === 'stone' ? 'finish' : null;
      if (/bow/.test(label)) return finish === 'bow' ? 'finish' : null;
      if (/strap|upper|bands?\b|t-bar|t-shaped|t-cut|four-way|4-way|h-cut|cross-cut|cross.lock|v-front|v-line|cutout|double.leaf|butterfly|interlock|toe-post|square.*profile|square-toe|pointed toe|rounded silhouette|fish-cut|envelope/.test(label)) return 'foundation';
      if (/block heel|kitten silhouette|stiletto silhouette|pencil heel|wedge silhouette|platform sole|wedge sole|wedge design|platform design|wedge profile/.test(label) && this.dataset.footwearType !== 'unknown') return 'foundation';
      if (/\b(black|white|ivory|cream|gold|golden|silver|bronze|copper|grey|gray|beige|taupe|mauve|pink|yellow|blue|green|nude|wine|tan|champagne|maroon|emerald|lavender|rainbow|coral)\b/.test(label) && /finish|hue|palette|tone|contrast|shimmer|matte|glossy|metallic/.test(label)) return 'colour';
      if (/handcrafted/.test(label)) return 'craft';
      if (/day-to-night/.test(label)) return 'occasion';
      return null;
    }

    _connectStrengths() {
      if (!this._connected) return;
      const scope = this.closest('main');
      if (!scope) return;
      const captions = new Set();
      this._featureLinks.forEach((_, link) => { if (!link.isConnected) this._featureLinks.delete(link); });
      scope.querySelectorAll(`.wl-design-strengths[data-product-id="${this.dataset.productId}"] .wl-design-strengths__item`).forEach((item) => {
        const text = item.textContent.trim();
        const feature = this._strengthDestination(text);
        const target = feature && this.querySelector(`[data-atelier-feature="${feature}"]`);
        if (!target || !target.id) return;
        if (feature === 'foundation') captions.add(text);
        if (item.querySelector('a')) return;
        const link = document.createElement('a');
        link.className = 'wl-design-strengths__link';
        link.href = `#${target.id}`;
        link.textContent = text;
        link.addEventListener('click', this._onFeatureClick);
        item.replaceChildren(link);
        this._featureLinks.set(link, target);
      });
      const caption = this.querySelector('[data-atelier-strength-caption]');
      if (caption) {
        caption.textContent = Array.from(captions).join(' · ');
        caption.hidden = captions.size === 0;
      }
    }

    _navigateFeature(event) {
      if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = this._featureLinks.get(event.currentTarget);
      if (!target?.isConnected) return;
      event.preventDefault();
      if (target.matches('details')) target.open = true;
      const card = target.closest('[data-atelier-card]');
      card?.setAttribute('data-revealed', 'true');
      this._featureTarget?.classList.remove('is-feature-target');
      clearTimeout(this._featureHighlightTimer);
      this._featureTarget = target;
      target.classList.add('is-feature-target');
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'start', behavior: this._reduced.matches ? 'auto' : 'smooth' });
      this._featureHighlightTimer = setTimeout(() => target.classList.remove('is-feature-target'), 2200);
      this._schedule(true);
    }

    _applyPreference() {
      this._stop();
      this._restore();
      const allowed = this.getAttribute('data-motion-enabled') !== 'false' && !this._reduced.matches;
      if (this._toggle) {
        this._toggle.hidden = !allowed;
        const label = this._toggle.getAttribute(this._paused ? 'data-play-label' : 'data-pause-label');
        if (label) this._toggle.textContent = label;
      }
      if (!allowed || this._paused || !this._connected) return;
      this.classList.add('has-motion');
      if (!this._compact.matches) this.classList.add('is-enhanced');
      this._cards.forEach((card) => {
        card.removeAttribute('data-revealed');
        card.style.setProperty('--wl-card-progress', '0');
      });
      this._lastProgress = undefined;
      this._cardProgress = new Map();
      this._floatValues = new Map();
      this._watchPointer(this._pointer.matches);
      if (!this._compact.matches) this._setActive(0);
      window.addEventListener('resize', this._onResize, { passive: true });
      window.addEventListener('load', this._onResize, { once: true });
      if ('ResizeObserver' in window) {
        this._resize = new ResizeObserver(this._onResize);
        new Set([this._track, this._stage, ...this._cards, ...this._floats]).forEach((node) => this._resize.observe(node));
        const main = this.closest('main');
        if (main) this._resize.observe(main);
      }
      const epoch = this._epoch;
      if ('IntersectionObserver' in window) {
        this._intersection = new IntersectionObserver((entries) => {
          if (epoch !== this._epoch || !this._connected) return;
          entries.forEach((entry) => {
            if (entry.isIntersecting) this._nearby.add(entry.target);
            else this._nearby.delete(entry.target);
          });
          this._watchScroll(this._nearby.size > 0);
          this._schedule(true);
        }, { rootMargin: '100% 0px' });
        new Set([this._track, ...this._cards, ...this._floats]).forEach((node) => this._intersection.observe(node));
      } else this._watchScroll(true);
      document.fonts?.ready.then(() => {
        if (epoch === this._epoch && this._connected) this._schedule(true);
      });
      this._schedule(true);
    }

    _watchScroll(shouldWatch) {
      if (shouldWatch === this._listening) return;
      if (shouldWatch) window.addEventListener('scroll', this._onScroll, { passive: true });
      else window.removeEventListener('scroll', this._onScroll);
      this._listening = shouldWatch;
    }

    _watchPointer(shouldWatch) {
      if (shouldWatch === this._pointerListening) return;
      this._floats?.forEach((node) => {
        if (shouldWatch) {
          node.addEventListener('pointermove', this._onPointerMove, { passive: true });
          node.addEventListener('pointerleave', this._onPointerLeave, { passive: true });
          node.addEventListener('pointercancel', this._onPointerLeave, { passive: true });
        } else {
          node.removeEventListener('pointermove', this._onPointerMove);
          node.removeEventListener('pointerleave', this._onPointerLeave);
          node.removeEventListener('pointercancel', this._onPointerLeave);
        }
      });
      this._pointerListening = shouldWatch;
    }

    _stop() {
      this._epoch += 1;
      this._watchScroll(false);
      this._watchPointer(false);
      this._floatPointers.clear();
      window.removeEventListener('resize', this._onResize);
      window.removeEventListener('load', this._onResize);
      this._intersection?.disconnect();
      this._resize?.disconnect();
      this._intersection = null;
      this._resize = null;
      this._nearby.clear();
      if (this._frame) cancelAnimationFrame(this._frame);
      this._frame = 0;
      this._needsMeasurement = false;
    }

    _restore() {
      this.classList.remove('is-enhanced');
      this.classList.remove('has-motion');
      this.removeAttribute('data-active-step');
      this.removeAttribute('data-in-view');
      this._inView = false;
      this._activeStep = -1;
      if (this._coreArt) this._coreArt.setAttribute('aria-label', this._coreArt.dataset.coreLabel);
      this._panels?.forEach((panel) => {
        panel.removeAttribute('data-active');
        panel.removeAttribute('aria-hidden');
        panel.inert = false;
      });
      this._steps?.forEach((step) => step.removeAttribute('aria-current'));
      this._cards?.forEach((card) => {
        card.setAttribute('data-revealed', 'true');
        card.style.removeProperty('--wl-card-progress');
      });
      this._floats?.forEach((node) => {
        ['--wl-float-progress', '--wl-float-tilt-x', '--wl-float-tilt-y'].forEach((property) => node.style.removeProperty(property));
      });
      ['--wl-progress', '--wl-open', '--wl-turn', '--wl-zoom', '--wl-detail', '--wl-press'].forEach((property) => this.style.removeProperty(property));
    }

    _schedule(measure = false) {
      this._needsMeasurement ||= measure;
      if (this._frame || !this._connected || !this.classList.contains('has-motion')) return;
      this._frame = requestAnimationFrame(() => {
        this._frame = 0;
        if (!this._connected || !this.classList.contains('has-motion')) return;
        if (this._needsMeasurement) this._measure();
        this._needsMeasurement = false;
        this._render();
      });
    }

    _measure() {
      const scroll = window.scrollY;
      const track = this._track.getBoundingClientRect();
      const stage = this._stage.getBoundingClientRect();
      this._geometry = {
        top: track.top + scroll,
        height: track.height,
        stageHeight: stage.height,
        viewport: window.innerHeight,
        distance: Math.max(1, track.height - stage.height),
        stickyTop: parseFloat(getComputedStyle(this._stage).top) || 0
      };
      this._cardGeometry = this._cards.map((card) => {
        const box = card.getBoundingClientRect();
        return { card, top: box.top + scroll, height: box.height };
      });
      this._floatGeometry = this._floats.map((node) => {
        const box = node.getBoundingClientRect();
        return { node, top: box.top + scroll, left: box.left + (window.scrollX || 0), height: box.height, width: box.width };
      });
    }

    _render() {
      const geometry = this._geometry;
      if (!geometry) return;
      const clamp = (value) => Math.max(0, Math.min(1, value));
      const ease = (value) => { const p = clamp(value); return p * p * (3 - 2 * p); };
      const scroll = window.scrollY;
      const trackTop = geometry.top - scroll;
      const enhanced = this.classList.contains('is-enhanced');
      const stageTop = enhanced ? Math.min(Math.max(trackTop, geometry.stickyTop), trackTop + geometry.height - geometry.stageHeight) : trackTop;
      const mainVisible = stageTop < geometry.viewport && stageTop + geometry.stageHeight > 0;
      const cardVisible = this._cardGeometry.some(({ top, height }) => top - scroll < geometry.viewport && top + height - scroll > 0);
      const floatVisible = this._floatGeometry.some(({ top, height }) => top - scroll < geometry.viewport && top + height - scroll > 0);
      const inView = mainVisible || cardVisible || floatVisible;
      if (inView !== this._inView) {
        this._inView = inView;
        if (inView) this.setAttribute('data-in-view', 'true');
        else this.removeAttribute('data-in-view');
      }
      const progress = clamp((scroll + geometry.stickyTop - geometry.top) / geometry.distance);
      const rounded = Number(progress.toFixed(4));
      if (enhanced && rounded !== this._lastProgress) {
        this._lastProgress = rounded;
        const open = progress < 0.22 ? ease(progress / 0.22) : 1 - ease((progress - 0.62) / 0.28);
        const detail = ease((progress - 0.3) / 0.15) * (1 - ease((progress - 0.6) / 0.15));
        const zoom = 1 + 0.15 * ease(progress / 0.45) * (1 - ease((progress - 0.65) / 0.3));
        const values = {
          '--wl-progress': rounded,
          '--wl-open': open,
          '--wl-turn': -8 + 16 * ease(progress),
          '--wl-zoom': zoom,
          '--wl-detail': detail,
          '--wl-press': ease((progress - 0.65) / 0.3)
        };
        Object.entries(values).forEach(([property, value]) => this.style.setProperty(property, Number(value.toFixed(4))));
        this._setActive(Math.min(this._panels.length - 1, Math.floor(progress * this._panels.length)));
      }
      this._cardGeometry.forEach(({ card, top, height }) => {
        const viewportTop = top - scroll;
        const cardProgress = Number(clamp((geometry.viewport - viewportTop) / Math.max(1, geometry.viewport + height)).toFixed(4));
        if (this._cardProgress.get(card) !== cardProgress) {
          this._cardProgress.set(card, cardProgress);
          card.style.setProperty('--wl-card-progress', cardProgress);
        }
        if (!card.hasAttribute('data-revealed') && viewportTop < geometry.viewport * 0.94 && viewportTop + height > 0) card.setAttribute('data-revealed', 'true');
      });
      this._floatGeometry.forEach(({ node, top, left, height, width }) => {
        const viewportTop = top - scroll;
        const pointer = this._floatPointers.get(node);
        const visible = viewportTop < geometry.viewport && viewportTop + height > 0;
        const x = pointer && visible && width > 0 ? clamp((pointer.x + (window.scrollX || 0) - left) / width) * 2 - 1 : 0;
        const y = pointer && visible && height > 0 ? clamp((pointer.y - viewportTop) / height) * 2 - 1 : 0;
        const values = [
          Number(clamp((geometry.viewport - viewportTop) / Math.max(1, geometry.viewport + height)).toFixed(4)),
          `${Number((-y * 5).toFixed(3))}deg`,
          `${Number((x * 8).toFixed(3))}deg`
        ];
        const previous = this._floatValues.get(node);
        ['--wl-float-progress', '--wl-float-tilt-x', '--wl-float-tilt-y'].forEach((property, index) => {
          if (!previous || previous[index] !== values[index]) node.style.setProperty(property, values[index]);
        });
        this._floatValues.set(node, values);
      });
    }

    _setActive(index) {
      if (index === this._activeStep) return;
      this._activeStep = index;
      this.setAttribute('data-active-step', String(index));
      if (this._coreArt) {
        const showFinish = index === this._panels.length - 1 && this._coreArt.querySelector('.wl-atelier__finish-reveal');
        this._coreArt.setAttribute('aria-label', showFinish ? this._coreArt.dataset.finishLabel : this._coreArt.dataset.coreLabel);
      }
      this._panels.forEach((panel, panelIndex) => {
        const active = panelIndex === index;
        panel.toggleAttribute('data-active', active);
        panel.setAttribute('aria-hidden', String(!active));
        panel.inert = !active;
      });
      this._steps.forEach((step, stepIndex) => {
        if (stepIndex === index) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
    }

    _navigate(event) {
      const step = event.target.closest('[data-atelier-step]');
      if (!step || !this.contains(step) || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const index = this._steps.indexOf(step);
      if (index < 0 || !this._panels[index]) return;
      if (!this.classList.contains('is-enhanced')) {
        if (step.tagName === 'BUTTON') this._panels[index].scrollIntoView({ behavior: 'instant', block: 'start' });
        return;
      }
      event.preventDefault();
      this._measure();
      const chapterPositions = [0.01, 0.4, 0.72, 0.96];
      const fraction = chapterPositions[index] ?? (index + 0.5) / this._panels.length;
      window.scrollTo({ top: this._geometry.top - this._geometry.stickyTop + this._geometry.distance * fraction, behavior: 'smooth' });
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
